import { useState } from 'react';

type UseCopyProps = {
  textToCopy?: string;
  onCopy?: (_text: string) => void;
};

export const useCopy = ({ textToCopy = '', onCopy }: UseCopyProps) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState<boolean>(false);

  const handleClick = async () => {
    await navigator.clipboard.writeText(textToCopy);
    onCopy?.(textToCopy);
    setIsTooltipOpen(true);

    setTimeout(() => {
      setIsTooltipOpen(false);
    }, 750);
  };

  return { isTooltipOpen, handleClick };
};
